import { REDUCE_POLICY_TEST_OVERRIDE } from '../../constants/actions/policy';

export function reducePolicyTestOverride(payload) {
    return {
        type: REDUCE_POLICY_TEST_OVERRIDE,
        payload,
    };
}
